import { coreAxios, solarSalesAxios } from '@infrastructure/apiService'
import { formatSupplyPoint } from '@modules/supply-point/infrastructure/supply-point.utils'
import { ISupplyPointRepository } from '@modules/supply-point/domain'

export const supplyPointService: ISupplyPointRepository = {
  getSupplyPointByCups: async (cups: string) => {
    const { data: supplyPoint } = await solarSalesAxios.get(
      `/${cups}/supply-point-consumption-status`
    )

    const { data: holder } = await coreAxios.get(
      `/private/supply-point/${cups}/holder`
    )

    const { consumption, status } = supplyPoint

    return formatSupplyPoint({
      ...consumption,
      status,
      ...holder,
    })
  },
}
